import React from 'react'
import styled from 'styled-components'
import { FieldTypeEnum, MeteDataRes } from 'packages/sdks-next/growp'
import { NumDescribe } from './NumDescribe'

/**
 * 问卷 - 题目
 *
 * @param param - 参数
 * @param param.type - 题目类型
 * @param param.label - 标题
 * @param param.require - 是否必填
 * @param param.metadata - metadata
 * @param param.currentIndex - 当前题目序号
 * @returns React.ReactNode
 */
export const BaseLabel: React.FC<{
  type: FieldTypeEnum
  label: string
  require: boolean
  metadata: MeteDataRes
  currentIndex: number
}> = ({ type, label, require, currentIndex, metadata }) => {
  const { minCount, maxCount } = metadata
  return (
    <LabelWrapper>
      <RequireMark>{require ? '*' : null}</RequireMark>
      <Label>
        {currentIndex}.{label}
        <NumDescribe
          type={type}
          minCount={minCount}
          maxCount={maxCount}
          fontSize={16}
        />
      </Label>
    </LabelWrapper>
  )
}

const LabelWrapper = styled.div`
  width: 100%;
  padding-left: 26px;
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.text._1};
`

const RequireMark = styled.div`
  width: 14px;
  font-size: 16px;
  padding-top: 6px;
  color: #f54545;
`

const Label = styled.div`
  font-size: 16px;
`
